import { render, staticRenderFns } from "./OpenServiceRequest.vue?vue&type=template&id=27bb50d2&scoped=true&"
import script from "./OpenServiceRequest.vue?vue&type=script&lang=js&"
export * from "./OpenServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./OpenServiceRequest.vue?vue&type=style&index=0&id=27bb50d2&prod&lang=scss&scoped=true&"
import style1 from "./OpenServiceRequest.vue?vue&type=style&index=1&id=27bb50d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb50d2",
  null
  
)

export default component.exports